import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import React, { useEffect, useState } from "react";
import {getCategories, getPhotos, getPhotosByCategory} from "../../context/photos/PhotoActions";
import Select from 'react-select';
import { 
  FaImages, 
  FaCheck, 
  FaTimes, 
  FaRedo, 
  FaSearch,
  FaSave,
  FaFolderOpen,
  FaCheckCircle
} from "react-icons/fa";
import './AddPhototoCanvas.css';

const host = process.env.REACT_APP_HOST || window.location.origin
const service = "https://develemosapp-file-test-e6aadvfzgyekf2bt.eastus2-01.azurewebsites.net/file/api/v1"

export default function AddPhotoToCanvas({ showModalPic, handleClose, setPhotosObjs,  saveQuestionToSession }) {

    const [photos, setPhotos] = useState([]);
    const [photosSelected, setPhotosSelected] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedOption, setSelectedOption] = useState({ value: 0 }); // Initialize with value 0
    const [selectAllChecked, setSelectAllChecked] = useState(false);

    const getCategoriesAndPhotos = async () => {

        const category = await getCategories();
        setCategories(category);
        setSelectedOption({ label: category[0].categoryName, value: category[0].id }); // Set default category
        const photosByCategory = await getPhotosByCategory( category[0].categoryName );
        setPhotos(photosByCategory);


    }

    useEffect(() => {
        getCategoriesAndPhotos();
    }, []);

    useEffect(() => {

        const getInfo = async () => {

            const photosByCategory = await getPhotosByCategory( selectedOption.label );
            setPhotos(photosByCategory);

            // Reset selectAllChecked when changing categories
            setSelectAllChecked(false);
        }

        getInfo();

    }, [selectedOption]);

    const handleSelectChange = (selectedOption) => {
        setSelectedOption(selectedOption)
    };

    const handleSelectAllChange = () => {

        if (selectAllChecked) {
            // Remove selected photos for current category
            setPhotosSelected(prevState => {
                const updatedSelected = { ...prevState };
                delete updatedSelected[selectedOption.value];
                return updatedSelected;
            });
        }else {
            // Add selected photos for current category

            const allPhotoIds = Object.values(photos).map(photo => ({
                id: photo.id,
                image: photo.uri,
                fileName: photo.fileName
            }));

            setPhotosSelected(prevState => ({
                ...prevState,
                [selectedOption.value]: allPhotoIds
            }));
        }
        setSelectAllChecked(!selectAllChecked);
    };

    const handleDeleteAllChange = () => {
        setPhotosSelected([])
        setPhotosObjs([])
    };

    const handlePhotoSelect = (photoId, photoFileName, uri) => {
        // Obtiene los IDs de fotos seleccionadas para la opción actual
        const selectedPhotos = photosSelected[selectedOption.value] || [];

        // Verifica si el ID de la foto ya está seleccionado
        const isPhotoSelected = selectedPhotos.some(photo => photo.id === photoId);

        // Si la foto ya está seleccionada, la elimina del estado
        if (isPhotoSelected) {
            setPhotosSelected({
                ...photosSelected,
                [selectedOption.value]: selectedPhotos.filter(photo => photo.id !== photoId)
            });
        } else {
            // Si la foto no está seleccionada, la agrega al estado
            setPhotosSelected({
                ...photosSelected,
                [selectedOption.value]: [...selectedPhotos, { id: photoId, image : uri,  fileName: photoFileName }]
            });
        }
    };

    const opts = [
        ...categories.map((category) => ({
            label: category.categoryName,
            value: category.id,
        })),
    ];

    useEffect(() => {

        const combinedPhotos = Object.values(photosSelected).flatMap(photos =>
            photos.map(photo => ({
                imageId: photo.id,
                image: `${service}/downloadFile/${photo.fileName}`,
                name: photo.fileName
            }))
        );
        setPhotosObjs(combinedPhotos)
    }, [photosSelected]);

    const isPhotoSelected = (photoId) => {
        return Object.values(photosSelected).some(photos => photos.some(photo => photo.id === photoId));
    };

    return (
        <Modal className='photo-selection-modal' show={showModalPic} onHide={handleClose} size="xl" centered>
            <Modal.Header className='modal-header-simple'>
                <Modal.Title>Seleccionar Imágenes Metafóricas</Modal.Title>
                <button 
                    type="button" 
                    className="btn-close-simple" 
                    onClick={handleClose}
                    aria-label="Cerrar"
                >
                    <FaTimes />
                </button>
            </Modal.Header>
            
            <Modal.Body className='modal-body-custom'>
                {/* Instructions */}
                <div className='instructions-section'>
                    <div className='instruction-content'>
                        <FaCheckCircle className='instruction-icon' />
                        <p>Selecciona fotos de varias categorías. Una vez finalizada la selección, guárdalas haciendo clic en "Guardar Fotos".</p>
                    </div>
                </div>

                {/* Controls Section */}
                <div className='controls-section'>
                    <div className='category-selector'>
                        <label className='control-label'>
                            <FaFolderOpen className='field-icon' />
                            Categoría
                        </label>
                        <Select
                            className='category-select'
                            value={selectedOption}
                            onChange={handleSelectChange}
                            options={opts}
                            isSearchable={true}
                            placeholder='Buscar categoría...'
                        />
                    </div>
                    
                    <div className='action-controls'>
                        <div className='select-all-control'>
                            <input
                                className='custom-checkbox'
                                type='checkbox'
                                id='selectAllCheckbox'
                                onChange={handleSelectAllChange}
                                checked={selectAllChecked}
                            />
                            <label htmlFor='selectAllCheckbox' className='control-label'>
                                Seleccionar Todo
                            </label>
                        </div>
                        
                        <button
                            onClick={handleDeleteAllChange}
                            className='reset-button'
                            title='Reiniciar selección'
                        >
                            <FaRedo className='reset-icon' />
                            Reiniciar
                        </button>
                    </div>
                </div>

                {/* Photos Grid */}
                <div className='photos-section'>
                    <div className='photos-grid'>
                        {photos.map((photo, index) => (
                            <div 
                                key={photo.id} 
                                className={`photo-card ${isPhotoSelected(photo.id) ? 'selected' : ''}`}
                                onClick={() => handlePhotoSelect(photo.id, photo.fileName, photo.uri)}
                            >
                                <div className='photo-container'>
                                    <img
                                        src={`https://develemosapp-file-test-e6aadvfzgyekf2bt.eastus2-01.azurewebsites.net/file/api/v1${photo.uri}`}
                                        alt={`Imagen ${index + 1}`}
                                        className='photo-image'
                                    />
                                    {isPhotoSelected(photo.id) && (
                                        <div className='selection-overlay'>
                                            <FaCheck className='check-icon' />
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer className='modal-footer-custom'>
                <button 
                    className='cancel-button'
                    onClick={handleClose}
                >
                    Cancelar
                </button>
                <button 
                    className='save-button'
                    onClick={() => {
                        saveQuestionToSession();
                        handleDeleteAllChange();
                    }}
                >
                    <FaSave className='me-2' />
                    Guardar Fotos
                </button>
            </Modal.Footer>
        </Modal>
    )
}
